import React from 'react';

const STATUS_STYLES = {
  active: 'bg-green-100 text-green-700',
  inactive: 'bg-yellow-100 text-yellow-700',
  suspended: 'bg-red-100 text-red-700',
};

export default function BusinessStatusBadge({ status }) {
  const s = status || 'active';
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${STATUS_STYLES[s] || STATUS_STYLES.active}`}>
      {s}
    </span>
  );
}
